<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryParams" :model="queryParams" :inline="true">
          <el-form-item label="平台" prop="platForm">
            <el-select v-model="queryParams.platForm" size="small" style="width: 130px" placeholder="请选择">
              <el-option
                v-for="item in platForm"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="国家" prop="startDate">
            <el-select v-model="queryParams.country" filterable size="small" style="width: 150px" placeholder="请选择">
              <el-option
                v-for="item in country"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button :loading="loading" type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
          </el-form-item>
        </el-form>

        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import { getUserVersionStat } from '@/api/statistics/user_remain'
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'IndexVersion',
  data() {
    return {
      loading: false,
      reelection: false,
      reelectionName: '',
      reelectionClick: 0,
      chart: null,
      option: null,
      platForm: [{ label: '全部', value: '' }, { label: '安卓', value: 1 }, { label: '苹果', value: 2 }, { label: 'TG', value: 3 }],
      country: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        country: '',
        platForm: ''
      }
    }
  },
  created() {
    this.getUserVersionData()
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      this.initChart()
    },
    getUserVersionData() {

    },
    initChart() {
      this.loading = true
      this.chart = echarts.init(this.$refs.chartContainer)
      this.chart.showLoading()
      this.option = {
        title: {
          text: '用户版本'
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: [],
          axisLabel: {
            interval: 0 // 设置为0，表示所有的标签都显示
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: { readOnly: false },
            // magicType: { type: ['line', 'bar'] },
            // restore: {},
            // saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }

      getUserVersionStat(this.queryParams).then(res => {
        this.loading = false
        this.chart.hideLoading()
        if (res.code === 200) {
          this.queryParams.startDate = res.data.req.startDate
          this.queryParams.endDate = res.data.req.endDate
          const country = res.data.country
          this.country = [{ value: '', label: '全部' }]
          for (const i in country) {
            this.country.push({ value: i, label: country[i] })
          }
          this.option.xAxis.data = []
          this.option.series = []
          const versionArr = {}
          const versionCount = {}
          const dateData = {}
          const dateArr = {}
          for (const i in res.data.data) {
            const val = res.data.data[i]
            if (val.version === 'undefined') {
              continue
            }
            versionArr[val.version] = val.version
            versionCount[val.version] = 0
            dateArr[val.date] = []
          }
          this.option.legend.data = []
          for (const i in dateArr) {
            dateData[i] = Object.assign({}, versionCount)
            this.option.xAxis.data.push(dateStrTodate(i))
          }

          for (const i in res.data.data) {
            const data = res.data.data[i]
            for (const k in dateData) {
              if (k === data.date) {
                const val = dateData[k]
                for (const v in val) {
                  if (v === data.version) {
                    val[v] += data.count
                  }
                }
                dateData[k] = val
              }
            }
          }
          this.option.series = []
          for (const i in versionArr) {
            const series = {
              name: '',
              data: [],
              type: 'line',
              smooth: true,
              label: {
                show: true,
                position: 'top', // 标签显示在折线图顶部
                formatter: '{c}' // 显示数值
              }
            }
            this.option.legend.data.push(i)
            series.name = i
            for (const k in dateData) {
              const val = dateData[k]
              for (const v in val) {
                if (series.name === v) {
                  // console.log(series1.name, v, val[v])
                  series.data.push(val[v])
                }
              }
            }
            this.option.series.push(series)
          }
          this.chart.setOption(this.option, true)
          // this.chart.on('legendselectchanged', this.handleClick)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleClick(params) {
      const clickName = params.name
      const selected = params.selected
      if (this.reelectionName === '') {
        this.reelectionName = clickName
        this.reelectionClick++
      } else if (this.reelectionName !== clickName) {
        this.resetLegend(selected)
        return
      }

      if (this.reelectionClick > 2 && this.reelectionName === clickName) {
        this.resetLegend(selected)
        return
      }

      this.reelectionClick++
      const reelection = this.reelection
      for (const i in selected) {
        if (i === clickName) {
          selected[i] = !reelection
        } else {
          selected[i] = reelection
        }
      }
      this.reelection = !reelection
      this.chart.setOption({
        legend: {
          selected: selected
        }
      })
    },
    resetLegend(selected) {
      for (const i in selected) {
        selected[i] = true
      }
      this.reelectionName = ''
      this.reelection = false
      this.chart.setOption({
        legend: {
          selected: selected
        }
      })
      this.reelectionClick = 0
    }
  }

}
</script>

<style scoped>

</style>
